/*
  Spray <-> Foam badalne par poore page ka content badal deta hai.

  Wajah: Dawn variant change par sirf product wala section refresh karta hai. Lekin
  Spray aur Foam ka farq poore page par hai — accent color, "One Formula" wala
  hissa, active ingredients ke icons, timeline ki video waghera. Is liye ek hi
  request mein poori page ki HTML mangwa kar <main> badal dete hain.

  Quantity (1 / 2 / 3 / 6 piece) badalne par ye kuch nahi karta — usay Dawn khud
  sambhalta hai, aur bundle cards pehle ki tarah kaam karte rehte hain.

  Ek chhota sa istisna: title ke neeche wala short description. Wo `main-product.liquid`
  se aata hai jise chhera nahi gaya, is liye us ka Spray/Foam text yahan se lagta hai.
  Text `product-accent-color` section JSON mein deta hai.

  Kuch bhi na mile (purane products, ya koi error) to page waise ka waisa rehta hai.
*/
(function () {
  if (window.__rxFormulaSwapInit) return;
  window.__rxFormulaSwapInit = true;

  var pending = null;
  var current = null;

  function checkedFormula() {
    var input = document.querySelector('input.rxss__radio:checked');
    return input ? (input.value || '').trim().toLowerCase() : null;
  }

  /* Dawn jis tarah option values bhejta hai, wahi tareeqa — server sahi variant
     chun kar poori page render kar deta hai. */
  function optionValueIds() {
    var selects = document.querySelector('variant-selects');
    if (!selects) return [];

    var nodes = selects.querySelectorAll('select option[selected], fieldset input:checked');
    var ids = [];
    Array.prototype.forEach.call(nodes, function (node) {
      var id = node.dataset ? node.dataset.optionValueId : null;
      if (id) ids.push(id);
    });
    return ids;
  }

  function escapeHtml(value) {
    var holder = document.createElement('div');
    holder.textContent = value;
    return holder.innerHTML;
  }

  function syncShortDescription() {
    var source = document.querySelector('script[data-rx-shortdesc]');
    var target = document.querySelector('.rx-shortdesc');
    if (!source || !target) return;

    var data;
    try {
      data = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }

    var text = current === 'foam' ? data.foam : data.spray;
    if (typeof text !== 'string' || text === '') return;

    target.innerHTML = escapeHtml(text).replace(/\r?\n/g, '<br>');
  }

  /* Swap ke dauran thodi der ke liye purani aur nayi <main> dono DOM mein hoti hain.
     Dono ke radio groups ka `name` ek jaisa hota hai (misal "Formula-2", "Quantity-1"),
     is liye browser unhein ek hi group samajh kar nayi wali ko uncheck kar deta hai —
     natija: na formula tab active dikhta hai, na bundle card.

     Server ne jo HTML bheji usme sahi radio par `checked` maujood hota hai, aur wo
     `defaultChecked` mein mehfooz rehta hai. Yahan bas wahi haalat wapas laga dete hain.
     Purani <main> 500ms baad hatti hai, is liye ye kayi baar chalta hai. */
  function restoreCheckedState() {
    document.querySelectorAll('variant-selects input[type="radio"]').forEach(function (input) {
      if (input.defaultChecked && !input.checked) input.checked = true;
    });
  }

  function reinjectScripts(root) {
    root.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attribute) {
        newScript.setAttribute(attribute.name, attribute.value);
      });
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function swap() {
    var ids = optionValueIds();
    if (!ids.length) return;

    var url = window.location.pathname + '?option_values=' + ids.join(',');

    if (pending) pending.abort();
    pending = new AbortController();

    fetch(url, { signal: pending.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Formula swap failed: ' + response.status);
        return response.text();
      })
      .then(function (text) {
        pending = null;

        var incoming = new DOMParser().parseFromString(text, 'text/html');
        var newMain = incoming.querySelector('main');
        var oldMain = document.querySelector('main');
        if (!newMain || !oldMain) return;

        if (typeof HTMLUpdateUtility === 'undefined') {
          /* Theme ka helper na mile to seedha replace — scripts dobara chalane
             padte hain warna accordions aur sliders mar jate hain. */
          oldMain.innerHTML = newMain.innerHTML;
          reinjectScripts(oldMain);
        } else {
          HTMLUpdateUtility.viewTransition(oldMain, newMain);
        }

        restoreCheckedState();
        [50, 300, 700].forEach(function (delay) {
          setTimeout(restoreCheckedState, delay);
        });

        current = checkedFormula() || current;
        syncShortDescription();

        document.dispatchEvent(new CustomEvent('rx:formula-changed', { detail: { formula: current } }));
      })
      .catch(function (error) {
        pending = null;
        if (error && error.name === 'AbortError') return;
        console.error(error);
      });
  }

  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || !el.classList || !el.classList.contains('rxss__radio')) return;

    var next = (el.value || '').trim().toLowerCase();
    if (!next || next === current) return;

    current = next;

    /* Dawn ko pehle apna kaam karne do (price, buy button, URL), phir hum poora
       page badal dete hain — warna dono ek doosre par chadh jate hain. */
    setTimeout(swap, 0);
  });

  function init() {
    current = checkedFormula();
    syncShortDescription();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
